import { FORGOT_PASSWORD } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { sendResetLink } from "../../api/authentication";

export const initialState = {
  isLoading: false,
  email: "",
  error: {
    hasError: false,
    errorMessage: "",
  },
};

const forgotPasswordSlice = createSlice({
  name: FORGOT_PASSWORD,
  initialState,
  reducers: {
    emailInput: (state, { payload }) => {
      state.email = payload;
    },
    reset: () => {},
  },

  extraReducers: (builder) => {
    builder.addCase(sendResetLink.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(sendResetLink.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode !== 200) {
        state.error.hasError = true;
        state.error.errorMessage = payload?.data?.message;
      }
      state.isLoading = false;
    });
    builder.addCase(sendResetLink.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.data?.message;
      state.isLoading = false;
    });
  },
});
export const ForgotPasswordActions = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
